import React, { Component } from 'react';
import { Button } from '../../node_modules/react-bootstrap/lib/';
import axios from 'axios';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';


class SMSButton extends Component {

	constructor(props){
		super(props);
		this.state = {
			clicked: false,
			bsStyle: 'primary',
			isLoading: false,
			hide: this.props.hide,
			label: this.props.label
		};
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(){
		let testMode = '&test=1';
		let msg = 'Felicitaciones ';
		if(this.props.sendSMS){
			testMode = '';
		}
		if(this.props.prefix === ""){
			msg += this.props.message;
		}else{
			msg = this.props.prefix + ' ' + this.props.message;
		}
		
		let url = "https://servicio.smsmasivos.com.ar/enviar_sms.asp?api=1"+ testMode +"&usuario=EXPERTIME&clave=BB404F37&tos="+this.props.phone+"&texto="+msg;
		console.log(this.props.sendSMS, this.props.phone, msg, url);	
		this.setState({clicked: true, isLoading: true, label: "..."});

		axios.get(url)
		  .then( (response) => {
			    console.log(response.data); // ex.: { user: 'Your User'}
			    console.log(response.status); // ex.: 200
			    if(response.status === 200){ //status = OK
			    	this.setState({bsStyle: this.props.sendSMS ? 'success' : 'warning', isLoading: false, label: this.state.label});
			    }else{
			    	this.setState({bsStyle: 'danger', isLoading: false, label: 'Error'});
			    }   
		  });
	}

	render(){
		//console.log(this.state.hide);
		return (
			<Button bsStyle={this.state.bsStyle} bsSize="small" onClick={(e) => this.handleClick(e)}>
		      	{this.state.label}
		    </Button>
		);
	}

}




function mapStateToProps(state) {
  const { sendSMS, prefix } = state.reducerRegisterInfo;
  return { sendSMS, prefix };
}

export default connect(mapStateToProps)(SMSButton);
        				  



// WEBPACK FOOTER //
// ./src/containers/sms-button.js